import * as $ from "jquery";
import { Helper } from "./helper";

export class Authentication {
  private state: any;
    "https://comparesheets-backend-staging-95ffbf72e0e8.herokuapp.com/api";
  private helper: Helper;

  constructor(state: any) {
    this.state = state;
    this.helper = new Helper(state);
  }

  public async login(email: string) {
    console.log("Login attempt with:", email);
    // add spinner in the login button
    $("#loginButton").prop("disabled", true);
    $("#loginButton").html("Logging in...");
    try {
      // Get API key from environment or configuration
      const apiKey = this.getApiKey();
      if (!apiKey) {
        throw new Error("API key not configured");
      }

      const response = await fetch(`${process.env.COMPARESHEETS_API_BASE_URL}/activations`, {
        method: "POST",
        mode: "cors",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify({
          activation: {
            email,
            device_token: this.getTokenFromLocalStorage(email) || "",
          },
        }),
      });
      return await this.handleLoginResponse(response);
    } catch (error) {
      console.error("Activation failed:", error);
      this.helper.showError({
        message: "Authentication failed. Please check your connection and try again.",
      });
      $("#loginButton").prop("disabled", false);
      $("#loginButton").html("Login");
      return { success: false, data: {} };
    }
  }

  private getApiKey(): string | null {
    // Webpack DefinePlugin will replace process.env.COMPARESHEETS_API_KEY
    // with the actual string value at build time
    // @ts-ignore
    const apiKey = process.env.COMPARESHEETS_API_KEY;

    if (apiKey && apiKey !== "undefined") {
      return apiKey;
    }

    // Fallback: check if it's available from window object
    if (typeof window !== "undefined" && (window as any).COMPARESHEETS_API_KEY) {
      return (window as any).COMPARESHEETS_API_KEY;
    }

    console.error("API key not found. Make sure COMPARESHEETS_API_KEY is set in .env file");
    return null;
  }

  private async handleLoginResponse(response: Response) {
    console.log("Login response===================");
    const data = await response.json();

    if (response.status === 200) {
      this.saveTokenToLocalStorage(data.email, data.device_token, data.expires_at, data.is_free_trial);
      this.handleSuccessLogin(data.success_message);
      return { success: true, data: data };
    } else {
      this.deleteToken(data.activation.email);
      const errors: string[] = Object.values(data.errors as Record<string, string[]>).flat();
      this.handleErrorLogin(response.status, errors);
      return { success: false, data: {} };
    }
  }

  public autoLogin(): { success: boolean; data: any } {

    // Check all stored tokens to find a valid one
    const allTokens = this.getTokens();
    // console.log("All stored tokens:", allTokens);

    for (const email in allTokens) {
      const tokenData = allTokens[email];
      if (!tokenData) continue;

      const expiresAt = new Date(tokenData.expiresAt);
      // console.log(`Checking token for ${email}, expires at:`, expiresAt.toLocaleString());

      if (expiresAt > new Date()) {
        // console.log(`Valid token found for ${email}, auto-logging in...`);
        this.handleSuccessAutoLogin(`Welcome back, ${email}`);
        return {
          success: true,
          data: {
            email,
            device_token: tokenData.token,
            is_free_trial: tokenData.isFreeTrial
          }
        };
      } else {
        // console.log(`Token for ${email} has expired, removing...`);
        this.deleteToken(email);
      }
    }
    // console.log("No valid tokens found for auto-login");
    return { success: false, data: {} };
  }

  public async demoLogin() {
    // simulate a login response
    const response = {
      ok: true,
      json: () => Promise.resolve({ token: "demo-token" }),
    };
    return await this.handleLoginResponse(response as Response);
  }

  private getTokens() {
    return JSON.parse(localStorage.getItem("device_tokens") || "{}");
  }

  private setTokens(tokens: { [key: string]: string }) {
    localStorage.setItem("device_tokens", JSON.stringify(tokens));
  }

  private deleteToken(email: string) {
    const allTokens = this.getTokens();
    delete allTokens[email];
    this.setTokens(allTokens);
  }

  private saveTokenToLocalStorage(email: string, token: string, expiresAt: string, isFreeTrial: boolean) {
    const allTokens = this.getTokens();
    allTokens[email] = {token, expiresAt, isFreeTrial};
    this.setTokens(allTokens);
  }

  private getTokenFromLocalStorage(email: string) {
    const allTokens = this.getTokens();
    const tokenData = allTokens[email];

    if (!tokenData) {
      return;
    }

    const expiresAt = new Date(tokenData.expiresAt);

    console.log("Token from local storage:", tokenData);
    console.log("Token expires at:", expiresAt.toLocaleString());

    if (expiresAt < new Date()) {
      this.deleteToken(email);
    }
    else {
      return tokenData.token;
    }
  }

  private handleSuccessLogin(message: string) {
    this.helper.showSuccess({ message });
    $("#formContainer").toggle();
    // remove spinner from the login button
    $("#loginButton").prop("disabled", false);
    $("#loginButton").html("Login");
  }

  private handleSuccessAutoLogin(message: string) {
    this.helper.showSuccess({ message, cleanUp: true });
    $("#formContainer").hide();
  }

  private handleErrorLogin(status: number, errors: string[]) {
    if (status === 401) {
      this.helper.showWarning({
        message: errors.join(", "),
        id: "loginError",
        cleanUp: false,
      });
    } else {
      this.helper.showError({ message: "Login failed: " + status });
    }
    $("#loginButton").prop("disabled", false);
    $("#loginButton").html("Login");
  }
}
